export const AGENT_SUPERVISION_ID = 'agent_supervision';
export const CONTROL_LISTING_EDITION_ID = 'control_listing_edition';
export const CONTROL_LISTING_EDITION_FLAG = 'control_listing_edition';
export const AGENT_SUPERVISION_ENFORCEMENT_FLAG =
  'agent_supervision_enforcement';

export const CLE_DISABLE_POLICY_APPROVE_ALL = 'approve_all';
export const CLE_DISABLE_POLICY_REJECT_ALL = 'reject_all';

// `listing_edition_supervision_policy` values, mirroring
// LISTING_EDITION_SUPERVISION_POLICY_* in tokkobroker's core/constants.py.
export const SUPERVISION_POLICY_OPTIONS = [
  {
    value: 0,
    labelKey: 'RequireSupervisionToSetPropertiesAsAvailableDevelopments',
  },
  {
    value: 1,
    labelKey: 'RequireSupervisionToSetPropertiesAsAvailableOrDevelopments',
  },
  { value: 2, labelKey: 'RequireSupervisionToEditAvailableProperties' },
];

export const BRANCH_SCOPE_SEARCH_THRESHOLD = 10;

export const DEFAULT_SUPERVISION_COPY = {
  activate: {
    title: 'ActivateSupervisionSystemTitle',
    description: 'ActivateSupervisionSystemDescription',
  },
  deactivate: {
    title: 'DeactivateSupervisionSystemTitle',
    description: 'DeactivateSupervisionSystemDescription',
  },
};

export const DEFAULT_SUPERVISION_TOAST_KEYS = {
  activate: 'SupervisionSystemSaved',
  deactivate: 'SupervisionSystemSaved',
};

export const SUPERVISION_SYSTEMS = [
  {
    id: AGENT_SUPERVISION_ID,
    titleKey: 'AgentSupervisionTitle',
    descriptionKey: 'AgentSupervisionDescription',
    icon: 'icon-analisiscontactos',
    toastKeys: {
      activate: 'AgentSupervisionActivated',
      deactivate: 'AgentSupervisionDeactivated',
    },
    confirmationKeys: {
      activate: {
        title: 'ActivateAgentSupervisionTitle',
        description: 'ActivateAgentSupervisionDescription',
      },
      deactivate: {
        title: 'DeactivateAgentSupervisionTitle',
        description: 'DeactivateAgentSupervisionDescription',
        note: 'DeactivateAgentSupervisionNote',
      },
    },
  },
  {
    id: CONTROL_LISTING_EDITION_ID,
    titleKey: 'PropertyAndDevelopmentSupervisionSystem',
    descriptionKey: 'ControlListingEditionDescription',
    icon: 'icon-situacion',
    toastKeys: {
      activate: 'ControlListingEditionActivated',
      deactivate: 'ControlListingEditionDeactivated',
    },
    // Turning it off asks what to do with the pending reviews.
    hasCustomConfirmation: true,
  },
];

export const SUPERVISION_SYSTEM_BY_ID = SUPERVISION_SYSTEMS.reduce(
  (systemsById, system) => {
    systemsById[system.id] = system;
    return systemsById;
  },
  {}
);

// Mirroring AGENT_SUPERVISION_TIME_UNIT_* and AGENT_SUPERVISION_LOCK_MODE_* in
// tokkobroker's core/constants.py.
export const TIME_UNIT_MINUTES = 1;
export const TIME_UNIT_HOURS = 2;
export const TIME_UNIT_DAYS = 3;

export const TIME_UNIT_IN_SECONDS = {
  [TIME_UNIT_MINUTES]: 60,
  [TIME_UNIT_HOURS]: 60 * 60,
  [TIME_UNIT_DAYS]: 60 * 60 * 24,
};

export const TIME_UNIT_OPTIONS = [
  { value: TIME_UNIT_MINUTES, labelKey: 'AgentSupervisionTabMinutes' },
  { value: TIME_UNIT_HOURS, labelKey: 'AgentSupervisionTabHours' },
  { value: TIME_UNIT_DAYS, labelKey: 'AgentSupervisionTabDays' },
];

export const LOCK_MODE_TIMED = 1;
export const LOCK_MODE_UNTIL_MANUAL_UNLOCK = 2;

// The backend takes any duration; these are the ones offered.
export const LOCK_DURATION_OPTIONS = [
  { mode: LOCK_MODE_TIMED, value: 24, unit: TIME_UNIT_HOURS },
  { mode: LOCK_MODE_TIMED, value: 48, unit: TIME_UNIT_HOURS },
  { mode: LOCK_MODE_TIMED, value: 72, unit: TIME_UNIT_HOURS },
];

export const TOLERANCE_KINDS = ['warning', 'lock'];

export const MAX_TOLERANCE_VALUE = 1000000;

// One per AGENT_SUPERVISION_ACTION_CHOICES, in the order the backend sends
// them. Login is only logged: the backend rejects tolerances on it.
export const AGENT_SUPERVISION_EVENTS = {
  login: {
    titleKey: 'UserLogin',
    descriptionKey: 'AgentSupervisionTabThisEventDoesntWarnOrBlockTheAgent',
    acceptsTolerances: false,
  },
  property_status_search: {
    titleKey: 'SearchOfUnavailableReservedProperties',
    descriptionKey: 'UsageOfTheSearchFilterToViewPropertiesWithStatus',
    acceptsTolerances: true,
  },
  unpublished_property_search: {
    titleKey: 'SearchForUnlistedPropertiesOnTheWebsite',
    descriptionKey:
      'UsageOfTheSearchFilterToViewPropertiesThatWereNotPublished',
    acceptsTolerances: true,
  },
  owner_contact_details_requested: {
    titleKey:
      'AgentSupervisionTabAccessToInformationFromOwnersAssignedToOtherAgents',
    descriptionKey: 'PropertyOwnerDataViewing',
    acceptsTolerances: true,
  },
  property_file_downloaded: {
    titleKey: 'FileDownloadFromFileManagerPropertyOrContact',
    descriptionKey: 'AgentSupervisionTabFileDownloadFromPropertyManager',
    acceptsTolerances: true,
  },
  property_pdf_generated: {
    titleKey: 'PropertyPdfFileGeneration',
    descriptionKey: 'PropertyPdfGenerationFromSearchbox',
    acceptsTolerances: true,
  },
  property_search_exported: {
    titleKey: 'PropertySearchResultsExport',
    descriptionKey: 'PropertyDataExportTo',
    acceptsTolerances: true,
  },
};
